import apiInstance from '../utils/axiosConfig';

const RoleService = {
    // Ajouter un nouveau rôle
    addRole: async (roleData) => {
        try {
            const response = await apiInstance.post('/role/add', roleData);
            return response.data;
        } catch (error) {
            console.error('Error adding role:', error.message || error);
            throw error;
        }
    },

    // Récupérer tous les rôles
    findAllRoles: async () => {
        try {
            const response = await apiInstance.get('/role/findall');
            return response.data;
        } catch (error) {
            console.error('Error fetching all roles:', error.message || error);
            throw error;
        }
    },

    // Récupérer un rôle par son ID
    findRoleById: async (id) => {
        try {
            const response = await apiInstance.get(`/role/find/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error fetching role by id:', error.message || error);
            throw error;
        }
    },

    // Mettre à jour un rôle
    updateRole: async (id, roleData) => {
        try {
            const response = await apiInstance.put(`/role/update/${id}`, roleData);
            return response.data;
        } catch (error) {
            console.error('Error updating role:', error.message || error);
            throw error;
        }
    },

    // Supprimer un rôle
    deleteRole: async (id) => {
        try {
            const response = await apiInstance.delete(`/role/delete/${id}`);
            return response.data;
        } catch (error) {
            console.error('Error deleting role:', error.message || error);
            throw error;
        }
    }
};

export default RoleService;